export default class SaveSolutionMinorVersionContentError extends Error {
}
